import React, { useContext } from "react";
import { AppContext } from "../../App";

export default function Events({ title, titleStyle, leftSection }) {
  const { colors } = useContext(AppContext);

  const styles = {
    container: leftSection,
    title: titleStyle,
  };

  const contentData = [
    {
      title: "  ",
      description:
        "הישיבה ממשיכה ללוות את בוגריה גם לאחר שנות הלימוד בין כתליה, ומקיימת מגוון אירועים שנועדו לשמור על הקשר, לחזק את תחושת השייכות וליצור הזדמנויות למפגש מחודש עם החברים ועם רבני הישיבה.\n\nבין האירועים שתוכלו למצוא כאן: שבתות בוגרים, מפגשי מחזור, בית מדרש לבוגרים, יום בר/בת מצווה וסיום התורה כולה. כל אירוע הוא הזדמנות להתחבר מחדש לרוח הישיבה, ליהנות מתוכן משמעותי ולהיות חלק מהמשפחה הגדולה של הבוגרים.\n\nפרטים נוספים על כל אירוע מופיעים בהמשך העמוד, ועדכונים שוטפים נשלחים בקבוצות הוואטסאפ ובמייל.",
    },

    {
      title: "שבתות בוגרים",
      description:
        "כחלק מהרצון של הישיבה לשמור על קשר עם בוגריה, אנו סוגרים את מלון שיר למעלות שליד הישיבה כמעט אחת לחודש, לטובת שבתות בוגרים. בכל שבת מגיעים בוגרי מחזור אחד, להיפגש עם החברים ועם צוות הישיבה. במהלך השבת מתקיימים פאנלים ושיחות עם ראש הישיבה והרבנים, וכן פעילויות לילדי הבוגרים. השבת אינה כרוכה בתשלום.",
    },
    {
      title: "מפגשי מחזור",
      description:
        "הישיבה מסייעת לארגון מפגשים מחזוריים, בזמן ובמיקום נוח לחברי המחזור, ובהשתתפות רבני הישיבה, על פי הרצון והצורך.\n\nלארגון מפגש מחזור פנו לרב מנחם.",
    },
    {
      title: "בית מדרש לבוגרים",
      description:
        "פרטים על מועד בית המדרש נשלחים בקבוצות הוואטסאפ ובמייל, ומפורסמים באתר ובפייסבוק. אם אינך מקבל מיילים מהישיבה, ניתן להירשם בטופס ליצירת קשר שבתחתית עמוד זה.",
    },
    {
      title: "יום בר/בת מצווה",
      description:
        "פעם בשנה הישיבה מקיימת אירוע חגיגי לבוגרים שבניהם או בנותיהם הגיעו לגיל מצוות. זהו יום מיוחד שמאפשר לחזור לישיבה, לפגוש חברים ורבנים, ולהכניס את ילדיכם לאווירת התורה והקהילה של הישיבה. האירוע כולל סיור חוויתי, שיעורים מיוחדים להורים ולילדים, מפגש עם ראש הישיבה והרבנים, וארוחה חגיגית משותפת. פרטים נוספים ומועד האירוע יתפרסמו בקבוצות הוואטסאפ ובמייל.",
    },

    {
      title: "סיום התורה כולה",
      description:
        "בוגרי הישיבה מוזמנים להשתתף באירועי סיום התורה כולה, המתקיים מדי שנה בישיבה. ביום זה אנו ביחד עם תושבי העיר מעלות כולה, מסיימים את כל התורה כולה. פרטים על המועד והמיקום נשלחים בקבוצות הוואטסאפ ובמייל.",
    },
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{title}</h2>

      {contentData.map((e, index) => (
        <div key={index}>
          <h3>{e.title}</h3>
          <p>{e.description}</p>
        </div>
      ))}
    </div>
  );
}
